"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M9.5 6.5c0 1.1-.9 2-2 2s-2-.9-2-2 2-3.5 2-3.5 2 2.4 2 3.5zM5.2142 20.0977 2 21.062v-2.0881l2.6395-.7919a3.0005 3.0005 0 0 1 1.72-.0012l6.571 1.9611 6.8568-3.066a.3595.3595 0 0 0-.2412-.6749l-3.5852.9778c-.4223.6508-1.1551 1.0891-2.0027 1.0891H10v-2h3.9582a.3853.3853 0 0 0 .0462-.768l-5.7817-.6979a.2855.2855 0 0 0-.1458.0209l-2.4448 1.0478a3.0004 3.0004 0 0 1-2.2351.0516L2 15.5984v-2.136l2.0992.7872a1 1 0 0 0 .745-.0172l2.4449-1.0477a2.283 2.283 0 0 1 1.1733-.1682l5.7816.6979a2.3857 2.3857 0 0 1 1.9471 1.5285l2.8287-.7714C20.5207 14.0621 22 15.192 22 16.7477a2.3593 2.3593 0 0 1-1.3962 2.1539l-6.8702 3.0721a1.9604 1.9604 0 0 1-1.361.0889l-6.585-1.9653a1.0002 1.0002 0 0 0-.5734.0004zM16.5 8.5c1.1 0 2-.9 2-2s-2-3.5-2-3.5-2 2.4-2 3.5.9 2 2 2zM14 10c0 1.1-.9 2-2 2s-2-.9-2-2 2-3.5 2-3.5 2 2.4 2 3.5z"
  })];
};

exports.default = _default;